module.exports = __webpack_public_path__ + "static/img/news_5.0412312.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news_5.jpg
// module id = FoZn
// module chunks = 0